import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';

import { EventTypes } from 'src/app/core/constants/event-types';
import { PeriodType } from 'src/app/core/enums/period-type.enum';
import { SetRateLimitRuleModel } from 'src/app/core/models/set-rate-limit-rule.model';
import { UtilityService } from 'src/app/core/services/utility.service';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { RegularExpressions } from '../../../../../core/constants/regular-expressions';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';

@Component({
    selector: 'app-create-rules-fields',
    templateUrl: './create-rules-fields.component.html',
    imports: [BaseFormModule]
})
export class CreateRulesFieldsComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region properties

  periodTypes = this.utilityService.enumToObjectWithTranslate(
    PeriodType,
    'PeriodType'
  );

  model: SetRateLimitRuleModel = {};
  @Input() index: number;
  @Input('rulesModel') rulesModel: SetRateLimitRuleModel;
  @Input('isEdit') isEdit: boolean;

  @Output('limit') output_limit = new EventEmitter<number>();
  @Output('period') output_period = new EventEmitter<string>();
  @Output('endpoint') output_endpoint = new EventEmitter<string>();
  @Output('periodType') output_periodType = new EventEmitter<PeriodType>();
  @Output('form') output_form = new EventEmitter<FormGroup>();

  @Output('removeIpRules') output_removeIpRules = new EventEmitter<number>();

  //#endregion

  constructor(private utilityService: UtilityService) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.fields = 'pages.ipRules.form.fields.';
      this.detectChangeForm();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.setting);
    }
  }

  initModel() {
    try {
      // when form is edit mode
      if (this.isEdit) {
        this.model = Object.assign({}, this.rulesModel);
      } // when form is create mode
      else this.formPageConfig.editData = {};
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.setting);
    }
  }

  initForm() {
    this.form = new FormGroup({
      limit: new FormControl('', [
        Validators.pattern(RegularExpressions.justNumber),
      ]),
      period: new FormControl('', [
        Validators.pattern(RegularExpressions.justNumber),
      ]),
      endpoint: new FormControl('', [Validators.required]),
      periodType: new FormControl('', [Validators.required]),
    });
  }

  //#region emit
  onChangeEndpoint() {
    this.output_endpoint.emit(this.model.endpoint);
  }
  onChangeLimit() {
    this.output_limit.emit(this.model.limit);
  }
  onChangePeriod() {
    this.output_period.emit(this.model.period);
  }
  onChangePeriodType() {
    this.output_periodType.emit(this.model.periodType);
  }

  onRemoveIpRules(i) {
    this.output_removeIpRules.emit(i);
  }

  emitForm() {
    this.output_form.emit(this.form);
  }

  //#endregion

  detectChangeForm() {
    try {
      this.form.valueChanges
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((event) => {
          this.emitForm();
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.setting);
    }
  }
}
